import React from 'react';
import './Page.css';
import usePageTitle from '../hooks/usePageTitle';

function OurLodge() {
  usePageTitle('Our Lodge');
  const currentYear = new Date().getFullYear();
  const yearsOfService = currentYear - 1856;

  return (
    <div className="page-container">
      <div className="page-hero our-lodge-hero" style={{ backgroundImage: 'url(/lodge-room.jpg)', backgroundPosition: 'center center' }}>
        <h1>Our Lodge</h1>
        <p>Muncy Lodge No. 299 F & A.M.</p>
      </div>

      <div className="page-content">
        <section className="content-section">
          <h2>Lodge History</h2>
          <p>
            Muncy Lodge No. 299 was constituted on June 25, 1856, when five Muncy men &mdash; led by William Cox Ellis, the lodge's first Worshipful Master &mdash; withdrew from Lodge No. 106 in Williamsport to establish a lodge of their own. For more than {yearsOfService} years, we have served the Muncy community and surrounding areas.
          </p>

          <figure className="history-figure history-figure-featured">
            <img src="/MuncyLodge1856Officers.png" alt="Portraits of Muncy Lodge No. 299's founding officers in 1856: William Cox Ellis (Worshipful Master), Thomas Wood (Senior Warden), and George Hill (Secretary)" />
            <figcaption>The founding officers of Muncy Lodge No. 299 in 1856: William Cox Ellis, P.M. (Worshipful Master), Thomas Wood, P.M. (Senior Warden), and George Hill, P.M. (Secretary).</figcaption>
          </figure>

          <p>
            In its early decades the lodge met in three historic buildings along South Main Street: <strong>Lloyd's Hall</strong> at 300&ndash;302 South Main Street (1856&ndash;1871), the <strong>Rankin Building</strong> at 13&ndash;15 South Main Street (1871&ndash;1906), and the <strong>Smith Building</strong> at 22&ndash;30 South Main Street (1906&ndash;2002), still known today as "The Masonic Building." The lodge made its home in the Smith Building for nearly a century before moving to its current location at 28 Brummer Pond Road in 2002.
          </p>

          <div className="history-photos">
            <figure className="history-figure">
              <img src="/LloydsHall.jpeg" alt="Lloyd's Hall at 300-302 South Main Street, the first meeting place of Muncy Lodge No. 299" />
              <figcaption>Lloyd's Hall, the lodge's first meeting place (1856&ndash;1871).</figcaption>
            </figure>
            <figure className="history-figure">
              <img src="/MasonicBuilding.jpg" alt="The Masonic Building sign on the historic Smith Building in Muncy, Pennsylvania" />
              <figcaption>The Smith Building, still known as "The Masonic Building," home of the lodge (1906&ndash;2002).</figcaption>
            </figure>
          </div>

          <p>
            Much of this history is drawn from <em>A Century of Masonry in Muncy, 1856&ndash;1956</em>, compiled for the lodge's 100th anniversary and published in 1956. It chronicles the lodge's founding, its meeting halls, its members, and its charitable and patriotic work across a full century.
          </p>
          <p>
            <a
              href="/A-Century-of-Masonry-in-Muncy-1856-1956.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="history-download-link"
            >
              Download the centennial history &mdash; A Century of Masonry in Muncy, 1856&ndash;1956 (PDF)
            </a>
          </p>

          <p>
            <strong>History is alive at Muncy Lodge, because we are building it!</strong>
          </p>
        </section>

        <section className="content-section">
          <h2>2026 Lodge Officers</h2>
          <div className="officers-grid">
            <div className="officer-card">
              <h3>Worshipful Master</h3>
              <p className="officer-name">Shannon C. Prutzman, P.M.</p>
            </div>
            <div className="officer-card">
              <h3>Senior Warden</h3>
              <p className="officer-name">Richard A. Thompson III</p>
            </div>
            <div className="officer-card">
              <h3>Junior Warden</h3>
              <p className="officer-name">Chris E. Miller, P.M.</p>
            </div>
            <div className="officer-card">
              <h3>Treasurer</h3>
              <p className="officer-name">Blake C. Marks</p>
            </div>
            <div className="officer-card">
              <h3>Secretary</h3>
              <p className="officer-name">John L. DeWald Jr., P.M.</p>
            </div>
          </div>
        </section>

        <section className="content-section">
          <h2>Location & Directions</h2>
          <div className="location-info">
            <div className="address-block">
              <h3>Muncy Lodge Hall</h3>
              <p>28 Brummer Pond Rd<br />Muncy, PA 17756</p>
              <p className="meeting-info">
                <strong>Stated Meetings:</strong> First Thursday of each month at 7:30 PM
              </p>
            </div>
            <div className="map-container">
              <iframe
                title="Muncy Lodge Location"
                src="https://www.google.com/maps?q=28+Brummer+Pond+Rd,+Muncy,+PA+17756&output=embed"
                width="100%"
                height="300"
                style={{ border: 0, borderRadius: '8px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default OurLodge;
